/**
 * Override angular ErrorHandler to provide custom error
 * More Info: https://angular.io/api/core/ErrorHandler 
 */
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core'

import Raven from 'raven-js';

declare let Messenger: any;

const handledStatusCodes = [563, 564, 565, 401, 500, 400, 403, 0];
@Injectable()
export class CustomErrorHandler extends ErrorHandler {

    constructor(private http: HttpClient){
        super();
    }

    handleError(error: Error) : void {
      if(!HIDE_JS_ERRORS) {
        let errorContent = `
        <b>Oops! Something went wrong.</b>
        <br/> 
        ${error.message || error['responseText']}
        <br/>
        `;
        Messenger.options = { extraClasses: 'messenger-fixed messenger-on-bottom messenger-on-right', theme: 'air' };
        Messenger().post({
          message: errorContent,
          type: 'error',
          showCloseButton: true,
          hideAfter: false
        });
      }

      //report error to raven
      if (SENTRY_DSN && SENTRY_ENABLED && (APP_ENV != 'local')) {
        if (this.isError(error)) {
          if (error['rejection'] && (handledStatusCodes.indexOf(error['rejection'].status) > -1)) {
            const message = `[Custom] captured failed angular http request with status ${error['rejection'].status}...`;
            Raven.captureBreadcrumb({
              message,
              category: 'angular-http',
              data: error['rejection'],
              level: 'error'
            });
            Raven.captureException(message);
          } else {
            Raven.captureException(error);
          }
        } else {
          Raven.captureException(new Error(JSON.stringify(error)));
        }
      }

      // delegate error to orginal handler
      super.handleError(error);
    }

    /**
     * Replicating Sentry's Error classification functionality
     * For More Details:
     * https://github.com/getsentry/raven-js/blob/master/packages/raven-js/src/raven.js#L469
     * https://github.com/getsentry/raven-js/blob/master/packages/raven-js/src/utils.js
     * 
     */
    isError(value){
      switch (Object.prototype.toString.call(value)) {
        case '[object Error]':
          return true;
        case '[object Exception]':
          return true;
        case '[object DOMException]':
          return true;
        case '[object ErrorEvent]':
          return value.error ? true : false;
        case '[object DOMError]': 
          return true;
        default:
          return value instanceof Error;
      }
    }
}